/**
 * ProfileTabPlaceholder.js
 * ========================
 *
 * Stub for the Profile tab. The notification system plan introduces
 * the Settings shell but the Profile UI proper is not in scope - it's
 * a separate effort that will edit ``users.name``, ``users.username``,
 * ``users.timezone``, etc. via the existing ``update_user_profile``
 * endpoint. For now this placeholder makes the Profile tab navigable
 * so the shell renders coherently.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Paper, Stack, Typography } from '@mui/material';

const ProfileTabPlaceholder = () => {
  const user = useSelector((s) => s.user_getUser?.response?.user) || {};
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack spacing={1.5}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>Profile</Typography>
        <Typography variant="body2" color="text.secondary">
          Personal account details. Editing in this tab is not enabled yet.
        </Typography>

        <Stack direction="row" spacing={2} sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>
            Name
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user.name || '-'}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>
            Email
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user.email || '-'}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>
            Timezone
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user.timezone || 'UTC'}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ProfileTabPlaceholder;
